<template>
  <notification
    type="is-success"
    icon="fa-check"
    @delete="$emit('delete')"
    :snackbar="snackbar"
  >
    <div v-html="content"></div>
  </notification>
</template>

<script>
import { Notification } from "%notifications";

export default {
  name: "success-notification",

  components: {
    Notification
  },

  props: {
    content: String,
    snackbar: {
      type: [Boolean, Number],
      default: true
    }
  }
};
</script>

<style></style>
